import { render } from "./notasEjaFundamentalUm.vue?vue&type=template&id=42b2e08a&scoped=true"
import script from "./notasEjaFundamentalUm.vue?vue&type=script&lang=js"
export * from "./notasEjaFundamentalUm.vue?vue&type=script&lang=js"

import "./notasEjaFundamentalUm.vue?vue&type=style&index=0&id=42b2e08a&lang=css"
import "./notasEjaFundamentalUm.vue?vue&type=style&index=1&id=42b2e08a&scoped=true&lang=css"
import "./notasEjaFundamentalUm.vue?vue&type=style&index=2&id=42b2e08a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b2e08a"]])

export default __exports__